import { IFormInformation, isFunction } from "@ngt/opms";
import { useMemo } from "react";
import { EConsentUserType } from "../../contexts/EConsentContext";
import { IEConsentForm } from "../../api/dtos";

const useEConsentFormReadOnly = <TFormValue extends IEConsentForm>(
    userType?: EConsentUserType | null,
    initialValue?: TFormValue,
    readOnly?: boolean | ((info: IFormInformation<TFormValue>) => boolean)
) => {
    const formReadOnly = useMemo(() => {
        const readOnlyValue = isFunction(readOnly) ? readOnly({ initialValue }) : readOnly;
    
        if (readOnlyValue === true) {
            return true;
        }

        return (!!initialValue?.patientSignedConsent && userType === EConsentUserType.Participant) || 
            (!!initialValue?.investigatorSignedConsent && userType === EConsentUserType.Investigator);

    }, [readOnly, initialValue, userType])

    return formReadOnly;
}

export default useEConsentFormReadOnly;